import * as moment from 'moment';

export class BlogPost {
    id: number;
    title: string;
    body:string;
    tile_image:string;
    header_image:string;
    summary:string;
    points:number;
    created_at:moment.Moment;
    updated_at:moment.Moment;
    completions:any;
    publish_date:moment.Moment;
    constructor(blogPost?) {
        if (blogPost) {
            this.id = blogPost.id;
            this.title = blogPost.title;
            this.body = blogPost.body;
            this.tile_image = blogPost.tile_image;
            this.header_image = blogPost.header_image;
            this.summary = blogPost.summary;
            this.points = blogPost.points;
            this.created_at = moment(blogPost.created_at);
            this.updated_at = moment(blogPost.updated_at);
            this.publish_date = moment(blogPost.publish_date);
            this.completions=blogPost.completions;
        }
    }
}
